import { jsPDF } from "jspdf";
import { CONTACT } from "./config";

export function downloadEstimatePdf(title, summary) {
  const doc = new jsPDF({ unit: "mm", format: "a4" });
  const W = 210;

  doc.setFillColor(11, 13, 17);
  doc.rect(0, 0, W, 30, "F");
  doc.setFillColor(255, 184, 0);
  doc.rect(0, 30, W, 1.6, "F");
  doc.setTextColor(255, 184, 0);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(22);
  doc.text("INFRA EDGE", 14, 14);
  doc.setTextColor(244, 246, 249);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(8);
  doc.text("CEMENT SOLUTIONS  ·  B2B SUPPLY ACROSS INDIA", 14, 21);
  doc.text(new Date().toLocaleString("en-IN"), W - 14, 14, { align: "right" });
  doc.text("Material Estimate", W - 14, 21, { align: "right" });

  let y = 48;
  doc.setTextColor(17, 17, 17);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.text(title, 14, y);
  y += 4;
  doc.setDrawColor(255, 184, 0);
  doc.setLineWidth(1.2);
  doc.line(14, y, 52, y);
  y += 10;

  doc.setFont("helvetica", "normal");
  doc.setFontSize(11);
  doc.setTextColor(60, 60, 60);
  const lines = doc.splitTextToSize(summary, W - 28);
  doc.text(lines, 14, y);
  y += lines.length * 6 + 10;

  doc.setFillColor(245, 246, 248);
  doc.roundedRect(14, y, W - 28, 28, 2, 2, "F");
  doc.setFontSize(9);
  doc.setTextColor(90, 90, 90);
  doc.text("Factors used: IS 456 mix proportions · dry volume 1.54 (concrete) / 1.33 (mortar & plaster)", 20, y + 9);
  doc.text("TMT unit weight d2/162 kg/m · 1 brass = 100 cu.ft = 2.832 cu.m", 20, y + 16);
  doc.text("Confirm final quantities with your site engineer before ordering.", 20, y + 23);

  doc.setFillColor(11, 13, 17);
  doc.rect(0, 275, W, 22, "F");
  doc.setTextColor(255, 184, 0);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(9);
  doc.text("Order this estimate from Infra Edge:", 14, 285);
  doc.setTextColor(244, 246, 249);
  doc.setFont("helvetica", "normal");
  doc.text(`WhatsApp ${CONTACT.whatsappDisplay}    ·    ${CONTACT.email}    ·    theinfraedge.com`, 14, 291);

  doc.save(`InfraEdge-${title.replace(/\s+/g, "-")}.pdf`);
}
